import { ApiCareerSnapshotSchema } from "@bridge-applications/pb-types";
import { z } from "zod";

export const CareerRuntimeSnapshotSchema = ApiCareerSnapshotSchema.omit({
    gnome: true,
});

export const CareerSliceSchema = z.object({
    snapshot: CareerRuntimeSnapshotSchema.nullable(),
    snapshotUserId: z.uuid().nullable().default(null),
    loadStatus: z.enum(["idle", "loading", "ready", "error"]),
    loadError: z.string().nullable(),
});

export type CareerSlice = z.infer<typeof CareerSliceSchema>;
export type CareerRuntimeSnapshot = z.infer<typeof CareerRuntimeSnapshotSchema>;
